import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Global: FC<IIconsProps> = ({
  color,
  size = IconScale.L,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.neutral['90'];
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="10" stroke={color} strokeWidth="2" />
      <path
        d="M15.5838 25.3415C11.1387 18.1825 11.1387 13.8175 15.5838 6.65849C15.7758 6.34928 16.2243 6.34929 16.4163 6.6585C20.8612 13.8175 20.8613 18.1825 16.4163 25.3415C16.2243 25.6507 15.7758 25.6507 15.5838 25.3415Z"
        stroke={color}
        strokeWidth="2"
      />
      <path d="M6 16H26" stroke={color} strokeWidth="2" />
      <path
        d="M7.6665 9.88892L11.8772 11.0118C14.5784 11.7321 17.4212 11.7321 20.1224 11.0118L24.3332 9.88892"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M7.6665 22.1111L11.8772 20.9882C14.5784 20.2679 17.4212 20.2679 20.1224 20.9882L24.3332 22.1111"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default Global;
